import api from './api';

export const getIntakeForms = (params) =>
  api.get('/api/v1/intake-forms', { params }).then((r) => r.data.data);

export const getIntakeForm = (id) =>
  api.get(`/api/v1/intake-forms/${id}`).then((r) => r.data.data);

export const createIntakeForm = (data) =>
  api.post('/api/v1/intake-forms', data).then((r) => r.data.data);

export const updateIntakeForm = (id, data) =>
  api.put(`/api/v1/intake-forms/${id}`, data).then((r) => r.data.data);

export const deleteIntakeForm = (id) =>
  api.delete(`/api/v1/intake-forms/${id}`).then((r) => r.data);

export const assignIntakeForm = (formId, clientId) =>
  api.post(`/api/v1/intake-forms/${formId}/assign`, { clientId }).then((r) => r.data.data);

export const getIntakeFormResponse = (responseId) =>
  api.get(`/api/v1/intake-forms/responses/${responseId}`).then((r) => r.data.data);

export const getFormLibrary = () =>
  api.get('/api/v1/intake-forms/library').then((r) => r.data.data);

export const importLibraryTemplate = (key) =>
  api.post(`/api/v1/intake-forms/library/${key}/import`).then((r) => r.data.data);

export const getClientAssessmentResponses = (clientId) =>
  api.get('/api/v1/intake-forms/responses', { params: { clientId } }).then((r) => r.data.data);

// ─── Form Sets ────────────────────────────────────────────────────────────────
export const getFormSets = () =>
  api.get('/api/v1/intake-form-sets').then((r) => r.data.formSets);

export const createFormSet = (data) =>
  api.post('/api/v1/intake-form-sets', data).then((r) => r.data.formSet);

export const updateFormSet = (id, data) =>
  api.put(`/api/v1/intake-form-sets/${id}`, data).then((r) => r.data.formSet);

export const deleteFormSet = (id) =>
  api.delete(`/api/v1/intake-form-sets/${id}`).then((r) => r.data);

export const assignFormSet = (id, clientId) =>
  api.post(`/api/v1/intake-form-sets/${id}/assign`, { clientId }).then((r) => r.data);
